import { chevronDown, chevronUp, externalLink } from '@mlc/symbols';
import {
	Accordion,
	Card,
	Heading,
	ScreenReaderText,
	Svg,
	Text,
	TextLink,
} from '@mlc/web-ui-toolkit';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import Link from '../../../../logic/domains/link.domain';
import { getPlanProfileTools } from '../../../../logic/functions/planProfileTools.function';
import { OpensNewWindow } from '../../../common/StaticContent';
import { ToolsHeading } from './Common/StaticContent';

const ToolsHeadingComponent = (
	<Heading el="h3" fontWeight="medium" fontSize="little">
		{ToolsHeading}
	</Heading>
);

const ToolListElement = ({ title, href }: { title: string; href: string }) => (
	<>
		<Card border="mlcBorderThin" borderColor="mlcDove" />
		<Card padding={2}>
			<TextLink target="_blank" href={href} data-id={_.snakeCase(title)}>
				<Text marginRight={2}>{title}</Text>
				<ScreenReaderText>{OpensNewWindow}</ScreenReaderText>
				<Svg symbol={externalLink} originalSize width="13px" />
			</TextLink>
		</Card>
	</>
);

const Tools: React.FunctionComponent = () => {
	const [toolLinks, setToolLinks] = useState<Link[]>();

	useEffect(() => {
		const fetchLinks = async () => {
			setToolLinks(await getPlanProfileTools());
		};
		fetchLinks();
	}, []);

	return (
		<>
			{toolLinks && (
				<Accordion
					el="h3"
					title={ToolsHeadingComponent}
					openSymbol={chevronDown}
					closeSymbol={chevronUp}
					noBorder={true}
					data-id={_.snakeCase(ToolsHeading)}
				>
					{toolLinks.map((toolLink, idx) => (
						<ToolListElement
							key={idx}
							title={toolLink.title}
							href={toolLink.url}
						/>
					))}
				</Accordion>
			)}
		</>
	);
};

export default Tools;
